import { Picker } from 'vant'
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
    name: 'carNoPicker',
    components: {
        'van-picker': Picker
    },
    props: {
        // defaultIndex
        defProv: {
            type: String,
            default: ''
        },
        defCity: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapState({}),
        ...mapGetters(['carNoBelongTo']),
        columns () {
            let { provs } = this.carNoBelongTo
            let defProv = this.carNoBelongTo.default
            let defCity = this.carNoBelongTo.default_letter_id
            // 先判断
            if (provs) {
                let prov_nameValus = Object.keys(provs)
                let prov_nameIndex = prov_nameValus.findIndex(
                    item => item === defProv
                )
                let CityValus = provs[defProv]
                let CityIndex = prov_nameValus.findIndex(
                    item => item.letter_id === defCity
                )
                return [
                    {
                        values: prov_nameValus,
                        className: 'column1',
                        defaultIndex: prov_nameIndex
                    },
                    {
                        values: CityValus,
                        className: 'column2',
                        defaultIndex: CityIndex
                    }
                ]
            } else {
                return []
            }
        }
    },
    methods: {
        ...mapActions(['getCarNoBelongTo']),
        async getCarNo () {
            await this.getCarNoBelongTo({
                lng: '113.32822500000', // 经度
                lat: '23.08375700000' // 纬度
            })
        },
        onChange (picker, values) {
            picker.setColumnValues(1, this.carNoBelongTo.provs[values[0]])
        },
        onConfirm (values) {
            // 发送事件
            this.$emit('confirm', values)
        },
        onCancel (values) {
            this.$emit('cancel', values)
            // 返回给上一个组件
        },
        onOpen () {
            this.show = true
        },
        onClose () {
            this.show = false
        }
    },
    data () {
        return {
            show: false
        }
    },
    async created () {},
    activated () {},
    mounted () {
        // this.onOpen()
    }
}
